<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.91674 10.9958C10.492 10.9958 10.9584 10.5295 10.9584 9.95421C10.9584 9.37894 10.492 8.9126 9.91674 8.9126C9.34147 8.9126 8.87512 9.37894 8.87512 9.95421C8.87512 10.5295 9.34147 10.9958 9.91674 10.9958Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.91674 3.70823C10.492 3.70823 10.9584 3.24188 10.9584 2.66662C10.9584 2.09135 10.492 1.625 9.91674 1.625C9.34147 1.625 8.87512 2.09135 8.87512 2.66662C8.87512 3.24188 9.34147 3.70823 9.91674 3.70823Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.91674 18.2956C10.492 18.2956 10.9584 17.8293 10.9584 17.254C10.9584 16.6787 10.492 16.2124 9.91674 16.2124C9.34147 16.2124 8.87512 16.6787 8.87512 17.254C8.87512 17.8293 9.34147 18.2956 9.91674 18.2956Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEllipsisVertical',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
